import { Page } from "@shared/pages/privacy-policy";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetStaticProps } from "next/types";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    return {
        props: {
            ...(await serverSideTranslations(locale ?? "cs", ["common"])),
        },
    };
};

export default Page;
